<template>
  <div class="fixed  mynav">
    <!-- <img src="../assets/img/beibeiebei.png" alt=""> -->
    <div class="topbar" style="margin:0 auto;background-color:white;z-index:1;background-color:unset;margin-left:50px">
      <div class="container-fluid ">
        <div class="container">
          <div class="row content" style="display: flex;">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-4 logo">
              <img src="../views/images/home/logo.png" alt="">
            </div>
            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-8">
              <div class="row" style="display: flex;align-items: center;">

                <el-menu :default-active="this.$route.path" mode="horizontal" router @select="handleSelect"
                  style="background-color:unset;">
                  <el-menu-item v-for="(item, i) in navList" :key="i" :index="item.name" @click="tiaozhuan(item.shang)">
                    {{item.navItem}}
                    <div class="rec hidden-xs sdsd" v-if="active == item.shang ">
                      <img src="../views/images/home/rec.png" alt="">
                      <!--  -->
                    </div>
                  </el-menu-item>
                </el-menu>

                <div
                  class="shoud col-lg-9 col-md-9 col-sm-10 col-xs-1 col-xs-offset-6 col-sm-offset-0 col-lg-offset-0 col-md-offset-0"
                  style="margin-left: 34%;">
                  <div class="icon visible-xs" @click="menu">
                    <span class="glyphicon glyphicon-menu-hamburger"></span>
                  </div>
                  <div class="item" :class="{'showItem':showItem,'hiddenItem':!showItem}">
                    <div v-for="(item,index) in list" :key="index" @click="itemClick(item,index)">
                      {{item.text}}
                      <!-- <div class="rec hidden-xs" v-show="item.active"><img src="../views/images/home/rec.png" alt=""></div> -->
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-2 col-xs-4">
                  <div class="search">
                    <div class="input">
                      <input type="text" placeholder="请输入关键词">
                      <img class="fdj" src="../assets/img/tuceng2.png" alt="" />
                    </div>
                    <!-- 登录后 -->
                    <el-dropdown @command="handleCommand" v-if="denglucg">
                      <div class="dengluhou">
                        <img src="../assets/img/topxiang.jpg">
                        <span>大胡子</span>
                        <i class="el-icon-caret-bottom"></i>
                      </div>
                      <el-dropdown-menu slot="dropdown" class="xialadeng">
                        <el-dropdown-item command="1">基本资料</el-dropdown-item>
                        <el-dropdown-item command="2">我的分数</el-dropdown-item>
                        <el-dropdown-item command="3">我的学生</el-dropdown-item>
                        <el-dropdown-item command="4">我的关注 </el-dropdown-item>
                        <el-dropdown-item command="5">我的选科</el-dropdown-item>
                        <el-dropdown-item command="6">性格测评</el-dropdown-item>
                        <el-dropdown-item command="7">收藏院校</el-dropdown-item>
                        <el-dropdown-item command="8">收藏专业</el-dropdown-item>
                        <el-dropdown-item command="9">优化志愿报告单</el-dropdown-item>
                        <el-dropdown-item command="10">退出登录</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <!-- 登陆前 -->
                    <div class="searchBtn hidden-sm hidden-xs" @click="diandenglu(true)" v-else>登录</div>


                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 退出登录 -->
      <div class="tuichuden" v-if="duichu == true">
        <div class="annou">
          <h1>退出登录</h1>
          <p>您确定要退出登录吗？</p>
          <dl>
            <dt @click="quxiao">取消</dt>
            <dd>确认</dd>
          </dl>
        </div>
      </div>

      <!-- 登录 -->
      <div class=" loginBody2" v-show="denglu" @click="qudiao">

      </div>
      <div class="loginAuto" v-show="denglu">
        <div class="logo"><img src="../views/images/dllogo.jpg"></div>
        <div class="loginItem">
          <ul class="loginTab flex">
            <li class="active">密码登录</li>
            <li>验证码登录</li>
          </ul>
          <!-- 密码登录 -->
          <div class="loginPage" style="display: block;">
            <ul class="loginList">
              <li>
                <i class="icon">
                  <img src="../views/images/icon_01.jpg">
                </i>
                <input class="text" placeholder="请输入账号" type="text" />
              </li>
              <li>
                <i class="icon">
                  <img src="../views/images/icon_02.jpg">
                </i>
                <input name="" type="password" class="text mima_dd " placeholder="请输入密码">
                <input name="" type="text" class="text mima_wz" style="display:none;" placeholder="请输入密码">
                <a class="eyes_box " data-show="1" href="javascript:void(0);"></a>
              </li>
              <li>
                <i class="icon">
                  <img src="../views/images/icon_03.jpg">
                </i>
                <input class="text" placeholder="图片验证码" type="text" />
                <div class="flex-items yzmBox">
                  <span class="yzm"><img src="../views/images/yzm.jpg"></span>
                  <a href="" class="tab">换一个</a>
                </div>
              </li>
              <li>
                <label><input type="checkbox" name="reading">记住我</label>
                <button class="btn">登录</button>
                <div class="flex-between">
                  <a class="open" href="">新用户注册</a>
                  <a class="open" href="">忘记密码？</a>
                </div>
              </li>
            </ul>
          </div>
          <!-- 验证码登录 -->
          <div class="loginPage" style="display: none;">
            <ul class="loginList">
              <li>
                <i class="icon">
                  <img src="../views/images/icon_01.jpg">
                </i>
                <input class="text" placeholder="请输入账号" type="text" />
              </li>
              <li>
                <i class="icon">
                  <img src="../views/images/icon_03.jpg">
                </i>
                <input class="text" placeholder="请输入验证码" type="text" />
                <button class="yanzhengma">发送验证码</button>
              </li>
              <li>
                <button style="margin: 0px;" class="btn">登录</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- <style scoped></style> -->
<script>
  export default {
    data() {
      return {
        // 是否登录
        denglucg: true,
        // 退出登录
        duichu: false,
        // 登录
        denglu: false,
        // 志愿填报二级
        erjie: false,
        activeIndex: "1",
        activeIndex2: "1",
        active: 1,
        navList: [{
            name: "/home",
            navItem: "网站首页",
            shang: 1,
          },
          {
            name: "/zyf",
            navItem: "院校资源",
            shang: 2,
          },
          {
            // name: {"/zhuanyezhiyuan":"/zyxq_zhuanyejieshao"},
            name: "/zhuanyezhiyuan",
            name2: "/zyxq_zhuanyejieshao",
            navItem: "专业资源",
            shang: 3,
          },
          {
            name: "/xuanzheyuanhuoye",
            // name: "/tiaobaozhiyuan",
            navItem: "志愿填报",
            shang: 4,
          },
          {
            name: "/gaokaozhixun",
            navItem: "高考资讯",
            shang: 5,
          },
          {
            name: "/kaoshengbidu",
            navItem: "考生必读",
            shang: 6,
          },
          {
            name: "/yishuzhaosheng",
            navItem: "艺术招生",
            shang: 7,
          },
          {
            name: "/Vip",
            navItem: "成为VIP",
            shang: 8,
          },
        ],
        showItem: false,
        list: [{
            text: "网站首页",
            active: false,
          },
          {
            text: "院校资源",
            active: false,
          },
          {
            text: "专业资源",
            active: false,
          },
          {
            text: "志愿填报",
            active: false,
          },
          {
            text: "高考资讯",
            active: false,
          },
          {
            text: "考生必读",
            active: false,
          },
          {
            text: "艺术招生",
            active: false,
          },
          {
            text: "成为VIP",
            active: false,
          },
        ]
      };
    },
    props: {
      inputName: Number,
      required: true
    },
    mounted() {
      var isAnimated = false
      $(document).ready(function() {
        //on() 添加监听  "所要监听的事件" function(){}当监听到事件后执行的方法
        $(window).on("scroll", function() {
          //this代表window scrollTop()向上滑动的距离
          if ($(this).scrollTop() > 100) {
            $(".mynav").addClass("fixed2");
            //如果动画执行过
          } else {
            $(".mynav").removeClass("fixed2");
          }
        })

      });

      console.log(this.inputName)
      this.active = this.inputName
      // this.duichu = true
      // 登录
      $('.loginTab li').click(function() {
        var el_index = $(this).parent().find('li').index(this);
        $(this).parent().find('li').removeClass('active');
        $(this).addClass('active');
        $(this).parent().parent().parent().find(".loginPage").hide();
        $(this).parent().parent().parent().find(".loginPage").eq(el_index).show();
      });
      $(function() {
        $(".eyes_box").click(function() {
          if ($(this).attr("data-show") == 1) {
            $(this).attr("data-show", "2");
            $(this).children("i").html("&#xe627;");
            $(this).parent("li").children(".mima_dd").hide();
            $(this).parent("li").children(".mima_wz").show();
            $(this).parent("li").children(".mima_wz").val($(this).parent("li").children(
              ".mima_dd").val());
            return;
          }
          if ($(this).attr("data-show") == 2) {
            $(this).attr("data-show", "1");
            $(this).children("i").html("&#xe624;");
            $(this).parent("li").children(".mima_dd").show();
            $(this).parent("li").children(".mima_wz").hide();
            $(this).parent("li").children(".mima_dd").val($(this).parent("li").children(
              ".mima_wz").val());
            return;
          }
        });
      });

      var times = 60;

      function roof() {
        if (times == 0) {
          $('.yanzhengma').text('发送验证码(' + times + 's)');
          $('.yanzhengma').prop('disabled', false);
          $('.yanzhengma').text('发送验证码');
          times = 10;
          return
        }
        $('.yanzhengma').text('重新发送(' + times + 's)');
        times--;

        setTimeout(roof, 1000);
      }
      $('.yanzhengma').on('click', function() {

        $(this).prop('disabled', true);
        roof();

      });
    },
    methods: {
      zhuanyeskdn() {
        this.$router.push('/tiaobaozhiyuan')
      },
      // 取消退出
      quxiao() {
        this.duichu = false
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
        // this.active = this.$route.path
        if (keyPath == "") {
          this.erjie = true
        }
      },
      // 移入
      mouseOver1(i) {
        // console.log('12',i)
        if (i == 3) {
          this.erjie = true
        } else {
          this.erjie = false
        }
      },
      // 移除
      mouseLeave() {
        this.erjie = false
      },
      diandenglu(obg) {
        // this.$emit('func', obg)
        this.denglu = true
        console.log(this.denglu)
      },
      qudiao() {
        this.denglu = false
      },
      tiaozhuan(shang) {
        this.active = shang
      },
      handleCommand(command) {
        // this.$message('click on item ' + command);
        console.log(command)
        if (command == 1) {
          this.$router.push('/gerenzhongxin')
        }
        if (command == 2) {
          this.$router.push('/grzx_wdfs')
        }
        if (command == 3) {
          this.$router.push('/grzx_wdxs')
        }
        if (command == 4) {
          this.$router.push('/grzx_wodeguanzhu')
        }
        if (command == 5) {
          this.$router.push('/grzx_wodexuanke')
        }
        if (command == 6) {
          this.$router.push('/grzx_xinggeceping')
        }
        if (command == 7) {
          this.$router.push('/grzx_shouchangxueyuan')
        }
        if (command == 8) {
          this.$router.push('/grzx_chouchangzhuanye')
        }
        if (command == 9) {
          this.$router.push('/grzx_wodezhiyuan')
        }
        if (command == 10) {
          this.duichu = true
        }


      },

      tuizhu() {
        this.duichu = true
      },
      menu() {
        if (!this.showItem) {
          this.showItem = true;
          var body = document.querySelector("body");
          body.style.overflow = "hidden"
        } else if (this.showItem) {
          this.showItem = false;
          var body = document.querySelector("body");
          body.style.overflow = ""
        }
      },
      itemClick(item, index) {
        this.showItem = false;
        this.list.forEach((item) => {
          item.active = false
        });
        item.active = true;
        if (index == 0) {
          this.$router.push('/home')
        }
        if (index == 1) {
          this.$router.push('/zyf')
        }
        if (index == 2) {
          this.$router.push('/zhuanyezhiyuan')
        }
        if (index == 3) {
          this.$router.push('/tiaobaozhiyuan')
        }
        if (index == 4) {
          this.$router.push('/gaokaozhixun')
        }
        if (index == 5) {
          this.$router.push('/kaoshengbidu')
        }
        if (index == 6) {
          this.$router.push('/yishuzhaosheng')
        }
        if (index == 7) {
          this.$router.push('/Vip')
        }
      }
    },
  };
</script>

<style scoped>
  /* 退出登录 */
  .tuichuden {
    z-index: 9;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
  }

  .annou {
    display: flex;
    flex-direction: column;
    width: 380px;
    height: 229px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 20px;
    padding: 0 21px;
    box-sizing: border-box;
  }

  .annou h1 {
    width: 100%;
    height: 48px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
    opacity: 1;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .annou p {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    flex: 1;
  }

  .annou dl {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .annou dl dt {
    cursor: pointer;
    width: 140px;
    height: 46px;
    background: rgba(200, 200, 200, 1);
    opacity: 1;
    border-radius: 23px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .annou dl dd {
    cursor: pointer;
    width: 140px;
    height: 46px;
    background: linear-gradient(129deg, #F53824 0%, #F44F25 61%, #F45D26 100%);
    box-shadow: 0px 0px 10px #F53824;
    opacity: 1;
    border-radius: 24px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .erjikuang2 {
    height: 200px;
    display: flex;
    align-items: center;
    flex-direction: column-reverse;
    position: absolute;
    left: 345px;
    top: 0px;
  }

  .erjikuang {
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 9999;
    border-radius: 8px;
    width: 100px;
    height: 100px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 16%);
  }

  .erjikuang li {
    width: 100%;
    line-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
  }

  .erjikuang i {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .erjikuang li:hover {
    background: rgba(200, 200, 200, 1);
    cursor: pointer;
  }


  /* 登陆后 */
  .dengluhou {
    margin-left: 14px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-shrink: 0;
    cursor: pointer;
  }

  .dengluhou img {
    height: 39px;
    border-radius: 50%;
  }

  .dengluhou span {
    font-size: 15px;
    font-family: MicrosoftYaHei;
    color: #333333;
    margin: 0 5px;
    flex-shrink: 0;
  }

  .dengluhou i {
    font-size: 14px;
    color: #29A7E1;
    flex-shrink: 0;
  }

  .xialadeng {
    width: 190px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .el-dropdown-menu__item {
    width: 100%;
    text-align: center;
  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    border: none !important;
    background-color: #F53824 !important;
    color: #FFFFFF;
  }

  .el-dropdown {
    margin-left: 14px;
  }


  .el-dropdown-link {
    cursor: pointer;
    color: #FFFFFF;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }

  .loginBody2 {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    z-index: 9999;
  }

  .loginAuto {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
  }

  @media (min-width: 1400px) {
    .container {
      width: 1528px;
    }
  }

  .sdsd {
    width: 32px;
    height: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .sdsd img {
    width: 32px;
    height: 7px;
  }

  .denglu button {
    color: white;
    width: 89px;
    height: 40px;
    background: linear-gradient(0deg, #f20e23, #f75d29);
    border-radius: 19px;
    border: none !important;

  }

  .header-right {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .header-right .search1 {
    margin-right: 12px;
    position: relative;
  }

  .header-right .search1 input {
    width: 209px;
    height: 40px;
    border: 1px solid #dedede;
    border-radius: 19px;
    padding-left: 15px;
    box-sizing: border-box;
  }

  ::-webkit-input-placeholder {
    color: #CAC9C9;
  }

  .header-center {
    display: flex;
    align-items: center;
  }

  .fdj {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 10px;
    right: 15px;
  }

  .header-left {
    display: flex;
    align-items: center;
  }

  .header-left img {
    width: 235px;
    height: 67px;
  }

  .header {
    height: 100px;
    display: flex;
    justify-content: space-between;
  }

  .el-menu.el-menu--horizontal {
    border: none !important;
  }

  .el-menu.el-menu--horizontal li {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: none;
  }

  .el-menu-item {
    font-size: 18px !important;
  }

  @media (max-width: 1400px) {}

  @media (max-width: 750px) {
    body {
      width: 100%;
      height: auto;
    }

    .topbar .content .search>.input {
      display: none;
    }

    .topbar .content .search>.input img {
      display: none;
    }

    .pcsd {
      display: none;
    }

    .header {
      display: none;
    }
  }



  .topbar {
    height: 88px;
  }

  .topbar .content {
    margin: 0px auto;
  }

  .topbar .content .logo {
    display: flex;
    height: 88px;
    justify-content: center;
    align-items: center;
  }

  .topbar .content .logo>img {
    width: 100%;
    height: 35px;
  }

  .topbar .content .item {
    display: block;
    overflow: hidden;
    height: 103px;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 99;
    background-color: #fff;
    width: 100%;
    height: 100%;
    left: -100%;
    top: 88px;
    padding: 25px;
    box-sizing: border-box;
    transition: 0s;
  }

  .topbar .content .item>div {
    cursor: pointer;
    font-size: 12px;
    height: 45px;
    font-size: 20px;
    text-indent: 25px;
    color: #333333;
  }

  .topbar .content .showItem {
    display: block;
    width: 100%;
    left: 0px;
    transition: 0.3s left;
  }

  .topbar .content .hiddenItem {
    display: block;
    width: 100%;
    left: -100%;
    transition: 0.5s left;
  }

  .topbar .content .icon {
    height: 88px;
    color: #333;
  }

  .topbar .content .icon>span {
    line-height: 88px;
    color: #333;
    cursor: pointer;
    font-size: 22px;
  }

  .topbar .content .icon:hover~.item {}

  .topbar .content .search {
    width: 100%;
    height: 88px;
    align-items: center;
    display: flex;
  }

  .topbar .content .search>.input {
    width: 100%;
    height: 35px;
    position: relative;
  }

  .topbar .content .search>.input>input {
    width: 100%;
    height: 35px;
    outline: none;
    border: 1px solid #DEDEDE;
    border-radius: 20px;
    padding: 0px 18px;
    font-size: 16px;
    box-sizing: border-box;
  }

  .topbar .content .search>.searchBtn {
    flex-grow: 1;
    width: 1px;
    height: 35px;
    border-radius: 17.5px;
    line-height: 35px;
    text-align: center;
    background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
    margin-left: 5px;
    color: #fff;
    font-size: 12px;
  }

  @media (max-width: 1200px) {}

  @media (min-width: 768px) {
    .shoud {
      display: none;
    }

    .topbar {
      height: 103px;
    }

    .topbar .content {
      margin: 0px auto;
    }

    .topbar .content .logo {
      display: flex;
      height: 103px;
      justify-content: center;
      align-items: center;
    }

    .topbar .content .logo>img {
      width: 100%;
      height: 35px;
    }

    .topbar .content .item {
      display: flex;
      width: 100%;
      height: 103px;
      justify-content: center;
      align-items: center;
      position: inherit;
      top: 0px;
      left: 0px;
      padding: 0px;
      transition: 0s;
    }

    .topbar .content .item>div {
      cursor: pointer;
      font-size: 12px;
      line-height: 0px;
      height: 100%;
      line-height: 103px;
      text-align: left;
      flex-grow: 1;
      text-align: center;
      text-indent: 0px;
      position: relative;
    }

    .topbar .content .item>div>.rec {
      position: absolute;
      top: auto;
      width: 32px;
      height: 7px;
      left: 0px;
      right: 0px;
      margin: 0px auto;
      bottom: 80px;
    }

    .topbar .content .search {
      width: 100%;
      height: 103px;
      align-items: center;
      display: flex;
      padding: 0px;
    }

    .topbar .content .search>.input {
      width: 115px;
      height: 35px;
      position: relative;
    }

    .topbar .content .search>.input>input {
      width: 100px;
      height: 35px;
      outline: none;
      border: 1px solid #DEDEDE;
      box-sizing: border-box;
      border-radius: 20px;
      padding: 0px 10px;
      font-size: 16px;
    }

    .topbar .content .search>.searchBtn {
      cursor: pointer;
      flex-grow: 1;
      width: 1px;
      height: 35px;
      border-radius: 17.5px;
      line-height: 35px;
      text-align: center;
      background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
      margin-left: 5px;
      color: #fff;
      font-size: 12px;
    }
  }

  /* 中等屏幕（桌面显示器，大于等于 992px） */
  @media (min-width: 992px) {
    .topbar {
      height: 103px;
    }

    .topbar .content {
      margin: 0px auto;
    }

    .topbar .content .logo {
      display: flex;
      height: 103px;
      justify-content: center;
      align-items: center;
    }

    .topbar .content .logo>img {
      width: 100%;
      height: 40px;
    }

    .topbar .content .item {
      display: flex;
      width: 100%;
      height: 103px;
      justify-content: center;
      align-items: center;
    }

    .topbar .content .item>div {
      cursor: pointer;
      height: 100%;
      line-height: 103px;
      text-indent: 0px;
      flex-grow: 1;
      text-align: center;
      position: relative;
    }

    .topbar .content .item>div>.rec {
      position: absolute;
      top: auto;
      width: 32px;
      height: 7px;
      left: 0px;
      right: 0px;
      margin: 0px auto;
      bottom: 80px;
    }

    .topbar .content .search {
      width: 100%;
      height: 103px;
      align-items: center;
      display: flex;
    }

    .topbar .content .search>.input {
      width: 115px;
      height: 35px;
      position: relative;
    }

    .topbar .content .search>.input>input {
      width: 115px;
      height: 35px;
      outline: none;
      border: 1px solid #DEDEDE;
      box-sizing: border-box;
      border-radius: 20px;
      padding: 0px 18px;
      font-size: 16px;
    }

    .topbar .content .search>.searchBtn {
      flex-grow: 1;
      width: 1px;
      height: 35px;
      border-radius: 17.5px;
      line-height: 35px;
      text-align: center;
      background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
      margin-left: 5px;
      color: #fff;
      font-size: 12px;
    }

  }


  @media (min-width: 1200px) {
    .topbar {
      height: 103px;
    }

    .topbar .content {
      margin: 0px auto;
    }

    .topbar .content .logo {
      display: flex;
      height: 103px;
      justify-content: center;
      align-items: center;
    }

    .topbar .content .logo>img {
      width: 100%;
      height: 50px;
    }

    .topbar .content .item {
      display: flex;
      width: 100%;
      height: 103px;
      justify-content: center;
      align-items: center;
    }

    .topbar .content .item>div {
      cursor: pointer;
      height: 100%;
      line-height: 103px;
      text-indent: 0px;
      flex-grow: 1;
      text-align: center;
      position: relative;
    }

    .topbar .content .item>div>.rec {
      position: absolute;
      top: auto;
      width: 32px;
      height: 7px;
      left: 0px;
      right: 0px;
      margin: 0px auto;
      bottom: 80px;
    }

    .topbar .content .search {
      width: 100%;
      height: 103px;
      align-items: center;
      display: flex;
    }

    .topbar .content .search>.input {
      width: 185px;
      height: 40px;
      position: relative;
    }

    .topbar .content .search>.input img {
      height: 18px;
      width: 18px;
      position: absolute;
      top: 10px;
      right: 15px;
    }

    .topbar .content .search>.input>input {
      width: 185px;
      height: 40px;
      outline: none;
      border: 1px solid #DEDEDE;
      box-sizing: border-box;
      border-radius: 20px;
      padding: 0px 18px;
      font-size: 16px;

    }

    .topbar .content .search>.searchBtn {
      flex-grow: 1;
      height: 40px;
      border-radius: 20px;
      line-height: 40px;
      text-align: center;
      background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
      margin-left: 5px;
      color: #fff;
    }


  }

  @media (max-width:750px) {

    /* 退出登录 */
    .annou {
      width: 85%;
    }

    .annou dl dt {
      width: 110px;
      height: 45px;
    }

    .annou dl dd {
      width: 110px;
      height: 45px;
    }
  }

  .el-menu--horizontal>.el-menu-item.is-active {
    color: white;
  }

  .el-menu {
    background-color: #f20e23;
  }

  /*固定定位*/
  .mynav {
    width: 100%;
    position: relative;
    height: 100px;
  }

  .fixed {
    margin-top: 0;
    /* z-index: 99; */
    background-color: white;
    width: 100%;
    height: 100px;
  }

  .fixed2 {
    position: fixed;
    top: -40px;
    z-index: 99;
    background-color: white;
    margin-top: 30px;
    width: 100%;
    height: 100px;
  }

  .el-menu--horizontal>.el-menu-item {
    color: black;
  }

  .el-menu--horizontal>.el-menu-item.is-active[data-v-7ee2c17a] {
    color: #333;
  }

  .el-menu--horizontal>.el-menu-item.is-active {
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/components/vmHeader.vue